import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { utils } from '../../../helper/utils';

export const PartsManagementListGridColumns: Array<TableColumn> = [
  {
    id: 'partCode',
    label: 'Part No.',
    sortDisabled: true,
  },
  {
    id: 'description',
    label: 'Description',
    sortDisabled: true,
  },
  {
    id: 'partManufacturerCode',
    label: 'Manufacturer Code',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue ? stringValue : '';
      },
    },
  },
  {
    id: 'partGroupCode',
    label: 'Part Group',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue ? stringValue : '';
      },
    },
  },
  {
    id: 'quantity',
    label: 'Quantity',
    dataType: {
      type: 'number',
      formatter: (value, row) => {
        return utils.numberFormatter.format(Number(value));
      },
    },
  },
  {
    id: 'price',
    label: 'Price USD',
    dataType: {
      type: 'number',
      formatter: (value, row) => {
        return utils.numberFormatter.format(Number(value));
      },
    },
  },
  {
    id: 'coreValue',
    label: 'Core Value USD',
    dataType: {
      type: 'number',
      formatter: (value, row) => {
        return utils.numberFormatter.format(Number(value));
      },
    },
  },
  {
    id: 'isActive',
    label: 'Active',
    sortDisabled: true,
  },
  {
    id: 'isSerialTagNumberRequired',
    label: 'Core',
    sortDisabled: true,
  },
  {
    id: 'deductCore',
    label: 'Deduct',
    sortDisabled: true,
  },
];
